import { Plus } from "lucide-react";

import { Button } from "@/components/ui/button";

interface NewThreadButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

export const NewThreadButton = ({
  onClick,
  disabled = false,
}: NewThreadButtonProps) => {
  return (
    <Button
      onClick={onClick}
      disabled={disabled}
      variant="ghost"
      className=" h-8 rounded-md px-3 border border-[#e8e8e8] text-[#1e1e24] hover:bg-transparent justify-start text-sm"
    >
      <Plus className="mr-1.5 h-3.5 w-3.5" /> New Chat
    </Button>
  );
};
